import axios from "axios";

// Kundenportal, the office side (/api/portal-admin)
const base = `${process.env.REACT_APP_BACKEND_URL}/portal-admin`;
const headers = () => ({ headers: { Authorization: "Bearer " + localStorage.getItem("token") } });

export const getPortalAccess = clientId => axios.get(`${base}/clients/${clientId}`, headers());
export const invite = clientId => axios.post(`${base}/clients/${clientId}/invite`, {}, headers());
export const revoke = clientId => axios.post(`${base}/clients/${clientId}/revoke`, {}, headers());
export const shareFile = (clientId, body) =>
  axios.post(`${base}/clients/${clientId}/shares`, body, headers());
export const unshare = (clientId, shareId) =>
  axios.delete(`${base}/clients/${clientId}/shares/${shareId}`, headers());
export const searchFiles = search =>
  axios.get(`${base}/files`, { ...headers(), params: { search } });
export const portalStatuses = ids => axios.post(`${base}/statuses`, { ids }, headers());

export const errorText = (error, fallback) => error?.response?.data?.errorMessage || fallback;
